import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectActiveLayer, getActiveStep, removeActiveLayer } from '../../../../../../redux/toolsSlice';
import { updateLayer } from '../../../../../../redux/stepsSlice';
import PersonalizationContentField from './PersonalizationContentField';

const TYPE_LABEL = {
  large_text: 'Heading', heading: 'Heading', body: 'Text', text: 'Text', button: 'Button',
};

const supportsText = (layer) => layer && (
  typeof layer.content === 'string'
  || ['large_text', 'body', 'button', 'heading', 'text'].includes(layer.type)
);

// BL-080 — inspector shown when a text/button element is selected: the
// personalizable Content field (chips + { } picker + preview), saving to the
// layer's `content` via updateLayer.
function ElementInspector() {
  const dispatch = useDispatch();
  const activeLayer = useSelector(selectActiveLayer);
  const activeStep = useSelector(getActiveStep);

  if (!activeLayer || !activeLayer.id || !supportsText(activeLayer)) return null;

  const onChange = (content) => {
    dispatch(updateLayer({ stepId: activeStep.id, layer: { ...activeLayer, content } }));
  };

  const typeLabel = TYPE_LABEL[activeLayer.type] || 'Element';

  return (
    <div className="un-insp un-insp--element">
      <div className="un-isel">
        <button type="button" className="un-isel__back" onClick={() => dispatch(removeActiveLayer())}>‹ Step</button>
        <span className="un-isel__cur">{typeLabel} element</span>
      </div>
      <div className="un-insp__body">
        <PersonalizationContentField label="Content" value={activeLayer.content || ''} onChange={onChange} />
      </div>
    </div>
  );
}

export default ElementInspector;
